import { Text } from "@akina/presentation";
import { clsx } from "clsx";

type TherapyCardProps = {
  name: string;
  description: string;
  selected: boolean;
  onClick: () => void;
};

export function TherapyCard({ name, description, selected, onClick }: Readonly<TherapyCardProps>) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        "w-full cursor-pointer rounded-2xl border-2 px-8 py-7 text-left transition-all duration-75",
        selected
          ? "border-primary-100 bg-white"
          : "hover:bg-primary-50 hover:border-gray-800/10 border-gray-800/10 bg-white",
      )}>
      <Text size="lg" fontWeight="font-bold" className="leading-6 text-gray-800">
        {name}
      </Text>
      <Text className="text-gray-800/90">{description}</Text>
    </button>
  );
}
